import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import { Button, Text } from '@BICE_Vida/components';

import styles from './AvailablePlans.module.scss';
import componentsId from '../../../utils/componentsId';
import {
  availablePlanCard,
  availablePlansSectionTexts,
  landingText,
} from '../../../utils/generalTexts';

import { UF as UFType } from '../../../types/uf';
import {
  AvailablePlans as AvailablePlansType,
  AvailablePlan as AvailablePlanType,
} from '../../../types/availablePlans';

import * as ufSelectors from '../../../redux/uf/selectors';
import * as plansSelectors from '../../../redux/plans/selectors';

import PlansComparisonTable from '@/components/PlansComparisonTable';
import routes from '@/utils/routes';
import { breakPointXl } from '@/utils/constants';
import { formatMoney } from '@/utils/format';
import AvailablePlanCard from '@/components/AvailablePlanCard';
import { clickActionsEvents, trackClick } from '@/utils/dataLayer/home';

const AvailablePlans = () => {
  const UF: UFType = useSelector(ufSelectors.getUF);
  const availablePlans: AvailablePlansType = useSelector(plansSelectors.getAvailablePlans);

  const dateFormatted = `${UF.day}/${UF.month}/${UF.year}`;

  const router = useRouter();

  const [showMobile, setShowMobile] = useState(false);

  useEffect(() => {
    const onResizeBenefits = () => setShowMobile(window.innerWidth < breakPointXl);

    window.addEventListener('resize', onResizeBenefits);
    onResizeBenefits();

    return () => {
      window.removeEventListener('resize', onResizeBenefits);
    };
  }, []);

  const goToWizardHandler = () => {
    trackClick({ action: clickActionsEvents.hirePlans });
    router.push(routes.wizardPlan);
  };
  const availablePlansFiltered = availablePlans.filter(
    (card: AvailablePlanType) => card.base !== null && card.hidePlan !== true
  );

  return (
    <section
      id={componentsId.landing.availablePlans.section}
      className={styles.available_plans_section}
    >
      <div className={styles.decorations_wrapper}>
        <div className={`${styles.corner_shape_left} ${styles.top_left}`} />
        <div className={`${styles.corner_shape_right} ${styles.bottom_right}`} />
      </div>
      <div className={styles.available_plans_container}>
        <Text className={styles.available_plans_title} tag="p">
          {landingText.availablePlans.title}
        </Text>
        <Text className={styles.available_plans_subtitle} tag="p">
          {landingText.availablePlans.subtitle}
        </Text>

        <div className={styles.available_plans_cards}>
          {showMobile ? (
            availablePlansFiltered.map((card, index: number) => (
              <AvailablePlanCard
                id={`${card.base}_card`}
                idx={index}
                customClass={styles.available_plans_card}
                availablePlan={card}
                UF={UF}
                key={index}
                btnAction={{
                  id: `${card.base}_btn`,
                  text: availablePlanCard.btn,
                  onClickEvent: () => {
                    trackClick({
                      action: clickActionsEvents.seeDetailPlan(card.description),
                    });
                  },
                }}
              />
            ))
          ) : (
            <PlansComparisonTable
              customClass={styles.available_plans_card}
              plans={availablePlansFiltered}
              UF={UF}
              btnAction={{
                id: componentsId.landingAvailablePlansCardBtn,
                text: availablePlansSectionTexts.coverageBtn,
              }}
            />
          )}
        </div>
        <div className={styles.available_plans_legend_section}>
        <span className={styles.disclaimer_text}>
          {landingText.coverages.warningUF(formatMoney(UF.value), dateFormatted)}
        </span>
      </div>
      </div>
      <div className={styles.available_plans_buttons}>
        <Button
          id={componentsId.landing.availablePlans.buttonNow}
          className={styles.hero_button}
          icon="arrow_forward"
          iconPosition="right"
          size="large"
          text={landingText.availablePlans.buttonNow}
          variant="primary"
          onClick={goToWizardHandler}
          aria-label={landingText.availablePlans.buttonNow}
        />
      </div>
    </section>
  );
};

export default AvailablePlans;
